module.exports = __webpack_public_path__ + "img/menu7.fe6f1124.png";